import React, { useEffect, useState } from "react";
import SingleItem from "./SingleItem";
import Skeleton from "react-loading-skeleton";

const Metal = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(
      `https://api.wlfmobile.com/api/user/trade/market/metals/mobile/filter/view`,
      {
        method: "GET",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return ;
  }

  return (
    <>
      <div className="markets-coin-lists">
        {data.map((data, index) => (
          <SingleItem data={data} key={data?._id} index={index}></SingleItem>
        ))}
      </div>
    </>
  );
};
export default Metal;
